const oneEthBI = BigInt('0xde0b6b3a7640000');
const FACTOR = 100_000;
const FACTOR_BI = BigInt(FACTOR);

export const AmountWithConversion = ({
  value,
  fiatCurrencySymbol,
  ethRate,
}: {
  value: bigint;
  fiatCurrencySymbol: string;
  ethRate: number;
}) => {
  const formatToEth = (bigNumber: bigint) =>
    (Number((bigNumber * FACTOR_BI) / oneEthBI) / FACTOR).toFixed(4);

  const formatToFiat = (bigNumber: bigint) =>
    (
      Number((bigNumber * BigInt(Math.round(FACTOR * ethRate))) / oneEthBI) /
      FACTOR
    ).toFixed(2);
  return (
    <div className="amount-with-conversion">
      <span>{formatToEth(value)}&nbsp;ETH</span>
      <span className="exponent">
        &#8776;&nbsp;{fiatCurrencySymbol}&nbsp;{formatToFiat(value)}
      </span>
    </div>
  );
};
